import { instance } from "./instance";
import { User, UserResponse, Request, RequestResponse, SocialUser } from "../types/user";

const axios = instance("USER");

export const signIn = async (user: User): Promise<UserResponse> => {
    const response = await axios.post<UserResponse>(`subscriber/login`, user);
    return response.data;
};

export const signUp = async (user: User): Promise<UserResponse> => {
    const response = await axios.post<UserResponse>(`subscriber/signup`, user);
    return response.data;
};

export const socialSignIn = async (user: SocialUser): Promise<UserResponse> => {
    const response = await axios.post<UserResponse>(`subscriber/social-login`, user);
    return response.data;
};

export const socialSignUp = async (user: SocialUser): Promise<UserResponse> => {
    const response = await axios.post<UserResponse>(`subscriber/social-signup`, user);
    return response.data;
};

export const changePassword = async (request: { oldPassword: string, newPassword: string }): Promise<UserResponse> => {
    const response = await axios.post(`subscriber/change-password`, request);
    return response.data;
};

export const request = async (request: Request): Promise<RequestResponse> => {
    const response = await axios.post<RequestResponse>(`request`, request);
    return response.data;
};

export const forgotPassword = async (request: { email: string }): Promise<RequestResponse> => {
    const response = await axios.post<RequestResponse>(`subscriber/forgot-password`, request);
    return response.data;
};